import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../lib/supabaseClient';
import './Dashboard.css';

const Dashboard = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      if (!supabase) {
        setError('Supabase ei ole käytettävissä. Tarkista ympäristömuuttujat.');
        setLoading(false);
        return;
      }

      try {
        const { data: { user: currentUser }, error: userError } = await supabase.auth.getUser();
        
        if (userError) {
          if (process.env.NODE_ENV !== 'production') {
            console.error('Dashboard fetch failed:', userError);
          }
          setError('Käyttäjätietojen haku epäonnistui. Kirjaudu uudelleen sisään.');
          setUser(null);
        } else {
          setUser(currentUser);
          setError(null);
        }
      } catch (err) {
        if (process.env.NODE_ENV !== 'production') {
          console.error('Dashboard fetch failed:', err);
        }
        setError('Odottamaton virhe käyttäjätietojen haussa.');
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, []);

  if (loading) {
    return (
      <div className="dashboard-loading">
        <div className="moon-loader">
          <div className="moon"></div>
        </div>
      </div>
    );
  }

  if (error || !user) {
    return (
      <div className="dashboard">
        <div className="container">
          <div className="error-message">
            {error || 'Käyttäjätietoja ei löytynyt. Kirjaudu uudelleen sisään.'}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard">
      <div className="container">
        <h1>Tervetuloa, {user.user_metadata?.name || user.email?.split('@')[0]}!</h1>

        {error && (
          <div className="error-message">{error}</div>
        )}

        <div className="dashboard-links">
          <Link to="/birth-data" className="dashboard-link">
            <h3>📝 Syntymätiedot</h3>
            <p>Tallenna syntymäaikasi ja paikkasi</p>
          </Link>

          <Link to="/charts" className="dashboard-link">
            <h3>🌟 Astrologiakartat</h3>
            <p>Näe omat syntymäkarttasi ja tulkinnat</p>
          </Link>

          <Link to="/files" className="dashboard-link">
            <h3>📁 Tiedostot</h3>
            <p>Lataa ja hallinnoi omia tiedostojasi</p>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
